var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94614 5.24714C5.6783 3.5148 8.77225 2.61838 12.6572 2.8772C12.9071 2.89385 13.1062 3.09288 13.1229 3.34282C13.382 7.22809 12.4858 10.3224 10.7535 12.0547C9.87959 12.9287 8.79876 13.4467 7.5811 13.5267C6.47223 13.5995 5.28332 13.3073 4.06514 12.6425L3.02009 13.6871C2.82478 13.8823 2.5082 13.8822 2.31298 13.6869C2.11777 13.4916 2.11785 13.175 2.31316 12.9798L3.3581 11.9354C2.69357 10.7173 2.40147 9.52841 2.47432 8.4196C2.55431 7.20195 3.07226 6.12111 3.94614 5.24714ZM4.80615 11.9016C5.79235 12.3931 6.70441 12.5821 7.51557 12.5288C8.47432 12.4659 9.33166 12.0624 10.0464 11.3476C11.4341 9.9599 12.3035 7.36678 12.1495 3.85061C8.63366 3.69689 6.04086 4.56649 4.65328 5.95421C3.93858 6.66899 3.53515 7.52636 3.47217 8.48515C3.41888 9.29627 3.60776 10.2083 4.09913 11.1944L6.3797 8.91325C6.57494 8.71796 6.89152 8.71793 7.0868 8.91316C7.28209 9.1084 7.28213 9.42498 7.08689 9.62027L4.80615 11.9016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/White.db5a1cba708f86dd928db1f71a2fdba3.svg";
export { ForwardRef as ReactComponent };